<!--
 * @Author: wsx
 * @Date: 2022-02-23 17:00:48
 * @LastEditTime: 2022-02-11 17:52:34
 * @LastEditors: Please set LastEditors
 * @Description: 展示图片
 * @FilePath: \smart-community\src\components\global\HPicture.vue
-->
<template>
  <div class="HSlider">
    <el-slider style="width: 100%" v-model="sliderValue"></el-slider>
    <el-input-number
      v-model="sliderValue"
      :min="15"
      :max="100"
      controls-position="right"
    >
    </el-input-number>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, watch, watchEffect } from "vue";
import { ElMessage } from "element-plus";
export default defineComponent({
  name: "HSlider",
  components: {},
  props: {
    silderNum: {
      type: Number,
      default: 35,
    },
  },
  emits: ["update:silderNum"],
  setup(props, { emit }) {
    const state = reactive({
      sliderValue: 75,
    });
    watchEffect(() => {
      emit("update:silderNum", state.sliderValue);
    });
    watch(() => {
      state.sliderValue = props.silderNum;
    });

    const refData = toRefs(state);
    return {
      ...refData,
    };
  },
});
</script>
<style lang="scss" scoped>
.HSlider {
  @include flex-row-c-c;
  .el-slider {
    width: 80%;
    margin-right: 8px;
  }
  // /deep/.el-input-number__decrease {
  //   display: none;
  // }
}
</style>
